import { render, staticRenderFns } from "./c_home_store.vue?vue&type=template&id=7bd848da&scoped=true"
import script from "./c_home_store.vue?vue&type=script&lang=js"
export * from "./c_home_store.vue?vue&type=script&lang=js"
import style0 from "./c_home_store.vue?vue&type=style&index=0&id=7bd848da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd848da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd848da')) {
      api.createRecord('7bd848da', component.options)
    } else {
      api.reload('7bd848da', component.options)
    }
    module.hot.accept("./c_home_store.vue?vue&type=template&id=7bd848da&scoped=true", function () {
      api.rerender('7bd848da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_store.vue"
export default component.exports